import { render } from "./EditSpeciality.vue?vue&type=template&id=8d103bb6&scoped=true"
import script from "./EditSpeciality.vue?vue&type=script&lang=js"
export * from "./EditSpeciality.vue?vue&type=script&lang=js"

import "./EditSpeciality.vue?vue&type=style&index=0&id=8d103bb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d103bb6"]])

export default __exports__